window.widget = () => {
    return {
        open: false,
        navbarIsSticky: false,

        toggle() {
            this.open = !this.open;
        },

        init() {
            this.setWidgetPosition();
            this.checkOrganizationIntersection();
        },

        openPtModal() {
            const modal = document.querySelector("[data-pt-modal]");
            if (modal && modal.__x) {
                modal.__x.$data.open();
            }
        },

        openWatchlist() {
            const watchlist = document.querySelector("[data-watchlist]");
            if (watchlist && watchlist.__x) {
                watchlist.__x.$data.open();
            }
        },

        setWidgetPosition() {
            const widgetElement = document.querySelector(".widget");
            widgetElement.classList.add("top-20");

            document.addEventListener("scroll", () => {
                // scrolling threshold 70px
                if (window.scrollY >= 70) {
                    widgetElement.classList.remove("top-20");

                    if (this.navbarIsSticky) {
                        return widgetElement.classList.add("top-20");
                    }

                    return widgetElement.classList.add("top-4");
                }

                widgetElement.classList.remove("top-4");
                widgetElement.classList.add("top-20");
            });
        },

        checkOrganizationIntersection() {
            const navbar = document.querySelector(".organization-navigation__wrapper");

            if (navbar) {
                const observer = new IntersectionObserver(
                    (entries, observer) => {
                        entries.forEach((entry) => {
                            this.navbarIsSticky = this.between(entry.intersectionRect.top, 0, 1);
                        });
                    },
                    {
                        rootMargin: "-1px 0px 0px 0px",
                        threshold: [1],
                    }
                );

                observer.observe(navbar);
            }
        },

        between(x, min, max) {
            return x >= min && x <= max;
        },
    };
};
